<template>
  <main>
    <p
      class="text-fg-default flex items-center gap-x-3 font-medium py-5 px-8 border-main absolute left-0 right-0 top-0 bg-white z-10 shadow-xs"
    >
      <i class="el-icon-arrow-left cursor-pointer" @click="goBack"></i>
      <span>Update Beneficiary</span>
    </p>
    <section class="px-8 pt-16 pb-3">
      <el-form
        label-position="top"
        :model="beneficiaryForm"
        ref="beneficiaryForm"
        :rules="rules"
        size="normal"
        @submit.prevent
        @keyup.enter.native="updateBeneficiaryDetails('beneficiaryForm')"
      >
        <el-form-item label="currency">
          <el-select
            disabled
            placeholder=""
            v-model="beneficiaryDetails.amount.amount"
          >
            <template #prefix>
              <span class="flex items-center px-3 mt-2 gap-x-3 bg-white z-10">
                <span class="text-fg-default">{{
                  beneficiaryDetails.amount.currency
                }}</span>
                <currency-icons
                  :currency="
                    getCurrencyCountry(beneficiaryDetails.amount.currency)
                  "
                />
              </span>
            </template>
            <el-option :value="beneficiaryDetails.amount.amount"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Amount" prop="amount">
          <el-input readonly v-model="formattedAmount"></el-input>
        </el-form-item>
        <el-form-item label="Full Name" prop="name">
          <el-input v-model="beneficiaryForm.name"></el-input>
        </el-form-item>
        <el-form-item label="Bank Code" prop="bankCode">
          <el-input v-model.trim="beneficiaryForm.details.bankCode"></el-input>
        </el-form-item>
        <el-form-item label="Account No" prop="details.accountNumber">
          <el-input
            v-model.trim="beneficiaryForm.details.accountNumber"
            name=""
          ></el-input>
        </el-form-item>
        <el-form-item label="Remarks" prop="remarks">
          <el-input v-model="beneficiaryForm.remarks"></el-input>
        </el-form-item>
        <el-form-item label="Swift Code" prop="swiftCode">
          <el-input v-model.trim="beneficiaryForm.swiftCode"></el-input>
        </el-form-item>
        <el-button
          class="bg-primary text-white rounded-lg shadow-sm px-8 text-center py-5 mb-5 mt-8 w-full"
          :loading="isLoading"
          @click="updateBeneficiaryDetails('beneficiaryForm')"
        >
          {{ isLoading ? 'Updating...' : 'Save' }}
        </el-button>
      </el-form>
    </section>
  </main>
</template>

<script>
import {
  ParseMoneyAll,
  GetCurrencyCountry,
  ValidateSwiftCode,
  ValidateInput,
  ValidateSingleSpace
} from '@/utils/helpers.js'
export default {
  props: {
    beneficiaryDetails: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  components: {
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue')
  },
  data () {
    return {
      isLoading: false,
      beneficiaryForm: {
        bankName: ''
      },
      formattedAmount: '',
      rules: {
        name: [
          {
            required: true,
            message: 'Please enter a valid full name',
            trigger: ['blur', 'change']
          },
          {
            validator: ValidateInput,
            trigger: ['blur', 'change']
          }
        ],
        'details.bankCode': [
          {
            required: true,
            message: 'Please enter a valid bank code',
            trigger: ['blur', 'change']
          },
          {
            validator: ValidateSingleSpace,
            trigger: ['blur', 'change']
          }
        ],
        'details.accountNumber': [
          {
            required: true,
            message: 'Please enter a valid account number',
            trigger: ['blur', 'change']
          },
          {
            validator: ValidateSingleSpace,
            trigger: ['blur', 'change']
          }
        ],
        swiftCode: [
          {
            message: 'Please enter a valid code',
            trigger: ['blur', 'change']
          },
          {
            validator: ValidateSwiftCode,
            trigger: ['blur', 'change']
          }
        ],
        remarks: [
          {
            message: 'Please enter a remark',
            trigger: ['blur', 'change']
          },
          {
            validator: ValidateInput,
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  methods: {
    goBack () {
      this.$emit('toggle-view', 'beneficiary-details')
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    updateBeneficiaryDetails (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateBulkPayout()
        } else {
          this.$notify.error({
            title: 'Invalid input',
            message: 'please fill all inputs correctly',
            position: 'top-right'
          })
        }
      })
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    async updateBulkPayout () {
      const payload = {
        id: this.beneficiaryDetails.id,
        formData: {
          accountNumber: this.beneficiaryForm.details.accountNumber,
          accountName: this.beneficiaryDetails.details.name,
          bankCode: this.beneficiaryDetails.details.bankCode
        }
      }
      this.isLoading = true
      const vm = this
      await this.$store
        .dispatch('bulkPayout/updateBulkPayout', payload)
        .then(() => {
          this.isLoading = false
          this.$emit('refresh')
          vm.$message({
            showClose: true,
            message: 'Beneficiary details updated successfully!',
            type: 'success'
          })
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  mounted () {
    this.beneficiaryForm = { ...this.beneficiaryDetails }
    this.formattedAmount = this.parseMoneyAll(
      this.beneficiaryDetails.amount.amount,
      this.beneficiaryDetails.amount.currency
    )
  }
}
</script>
<style scoped>
>>> .el-input__inner {
  border-radius: 0.25rem !important;
}
>>> .el-form-item {
  margin-bottom: 10px;
}
>>> .el-form-item__label {
  margin-bottom: -8px;
}
>>> .el-select {
  width: 100% !important;
}
</style>
